import { makeObservable, observable, toJS } from 'mobx'
import type { ICallingActionPayload, ICallingActionResponse } from 'entities/AICalling/api/types'
import { BaseCallingAction } from './BaseCallingAction'

export class AfterCallAction extends BaseCallingAction {
  constructor(item: ICallingActionResponse | ICallingActionPayload) {
    super(item)
    makeObservable(this, {
      message: observable,
      media_url: observable,
    })
  }

  get settings() {
    return {
      message: this.message,
      media_url: this.media_url,
    }
  }

  get payload() {
    const base = {
      action_type: this.actionType,
      trigger_type: this.triggerType,
      settings: this.settings,
    }
    if (this.serverId) {
      return toJS({ ...base, id: this.serverId })
    }
    return toJS(base)
  }
}
